export default "/images/a600f417e867495bc314c48aa7f9ffbe.avif";